import { render, staticRenderFns } from "./WasteHandlingSimulationEditView.vue?vue&type=template&id=3264854a&scoped=true&"
import script from "./WasteHandlingSimulationEditView.vue?vue&type=script&lang=js&"
export * from "./WasteHandlingSimulationEditView.vue?vue&type=script&lang=js&"
import style0 from "./WasteHandlingSimulationEditView.vue?vue&type=style&index=0&id=3264854a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264854a",
  null
  
)

export default component.exports